import React from 'react';
export function IdentityQuote() {
  return <section className="pull-quote-section" data-id="element-69">
      <blockquote className="pull-quote" data-id="element-70">
        La mayoría de las mujeres no se arrepienten por el procedimiento. Se
        arrepienten de no haberse preparado emocionalmente para él.
      </blockquote>
    </section>;
}